import { render, staticRenderFns } from "./printFormDelivery.vue?vue&type=template&id=74714224&scoped=true&"
import script from "./printFormDelivery.vue?vue&type=script&lang=js&"
export * from "./printFormDelivery.vue?vue&type=script&lang=js&"
import style0 from "./printFormDelivery.vue?vue&type=style&index=0&id=74714224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74714224",
  null
  
)

export default component.exports